import { Link } from '@mui/material';
import { useEventBus } from '../../../../../../hooks/use-event-bus';
import { PhoneType } from '../../../../../layout/slideout/patient-profile-widget/views/general/types';
import { Phone } from './overview.styles';

interface PhoneComponentProps {
  phoneNumber?: string;
  phoneType: PhoneType;
}

const convertTypeToLabel = (type: PhoneType) => {
  switch (type) {
    case PhoneType.Home:
      return 'H';
    case PhoneType.Mobile:
      return 'M';
    case PhoneType.Work:
      return 'W';
    default:
      return '';
  }
};

export function PhoneComponent({ phoneNumber, phoneType }: PhoneComponentProps) {
  const { publish } = useEventBus();

  const formattedPhone =
    phoneNumber && phoneNumber.length > 0
      ? `(${phoneNumber.substring(0, 3)})${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6)}`
      : '';

  if (!formattedPhone) return null;

  return (
    <Phone>
      {convertTypeToLabel(phoneType)}{' '}
      <Link
        style={{ textDecoration: 'none' }}
        onClick={() => {
          publish({
            messageType: 'startCall',
            data: {
              phoneNumber: formattedPhone
            }
          });
        }}
      >
        {formattedPhone}
      </Link>
    </Phone>
  );
}
